import React from 'react';
import { Input } from 'formsy-react-components';
import { PhoneInput } from './phone-input';

export const BasicInfo = React.createClass({
  render() {
    const { profile } = this.props;
    return (
      <div className="form-panel basic">
        <div className="heading">Basic Info</div>
        <hr />
        <Input
          label="Company Name"
          type="text"
          name="name"
          value={profile.get('name')}
          placeholder="Enter your company name"
          labelClassName="small-12"
          elementWrapperClassName="small-12"
          required
        />
        <PhoneInput phone={profile.get('phone')} />
      </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./src/components/profile/basic-info.jsx
 **/